import {
  AvatarUriLoad,
  getLanguageFromTags,
  getSeoUrl,
  interpolate,
  KissanEventType,
  saveImageToTempDir,
  truncateName,
  updateFollowStatusApi,
  useAppPersistenceStore,
  useGlobalLoginContext,
  useGlobalReportContext,
  useProfileStore,
  useRecommendedProducts,
} from '@ninjacart/nc-nk-store';
import {
  Avatar,
  Button,
  Card,
  Content,
  Image,
  ImagePreview,
  Paragraph,
  ShareSolidRegular,
  Stack,
  Text,
  useTheme,
  useTimeAgo,
  VideoPlayIconRegular,
  View,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
// import Video from 'react-native-video';
// import { useQnaFeedStore } from '@ninjacart/nc-nk-advisory';
import {
  IQnACommentRequestPayload,
  IQnACommentResponseItem,
  IQnADetailPayload,
  IQuestionAnswer,
  safeStringify,
} from '@ninjacart/nc-nk-core';
import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import NKPlayer from '@ninjacart/nc-nk-video';
import { handleContactPermission, Share, useRouter } from '@ninjacart/nc-nk-web-deps';
import { ChevronDown, MoreVertical, Pencil, Plus } from '@tamagui/lucide-icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, ImageBackground, Platform, Pressable } from 'react-native';
import { Link } from 'solito/link';
import { RecommendedProductsNudgeComponent } from '../products/productNudge/recommendedProductNudge';
import { QnAAnswersWithComments } from './qnaComments';
export const QuestionAnswerCard = ({
  item,
  index,
  questionId,
  showFeedbackOnReplies,
  pageName,
  showFollowOnCard,
  updateConnectionStatus,
  pageExpertName,
  createCommentQnA,
  getQnACommentList,
  onQnAReplyLike,
  useQnaFeedStore,
  lang,
}: {
  item?: IQuestionAnswer;
  index: number;
  questionId?: string;
  showFeedbackOnReplies?: boolean;
  pageName?: string;
  showFollowOnCard?: boolean;
  updateConnectionStatus?: Function;
  pageExpertName?: string;
  createCommentQnA: (config: any) => Promise<IQnACommentResponseItem>;
  getQnACommentList: (config: IQnACommentRequestPayload) => Promise<IQnACommentResponseItem[]>;
  onQnAReplyLike: (params: IQnADetailPayload) => Promise<any>;
  useQnaFeedStore: any;
  lang?: string;
}) => {
  const { push, back } = useRouter();
  const { t } = useTranslation();
  const userProfile = useProfileStore((state) => state.userProfile);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const screenWidth = Dimensions.get('window').width;
  const cardWidth = (screenWidth - 40 - 32) / 3;
  const feedConfig = useProfileStore((state) => state.feedConfig);
  const theme = useTheme();
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const [isFollowing, setIsFollowing] = useState(hasUserLoggedIn() ? item?.following : false);
  const setisAskQuestionDetailPage = useQnaFeedStore((state) => state.setisAskQuestionDetailPage);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const fields = useGlobalLoginContext(['openLoginSheet', 'previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;
  const reportfields = useGlobalReportContext(['reportIndex', 'openReportSheet']);
  const setCurrentIndex = reportfields['reportIndex'].set;
  const { recommendedProducts, fetchRecommendedProducts } = useRecommendedProducts();

  // const getExpertDetail = () => {
  //   if (item && item?.children?.length > 0) {
  //     // item?.children.forEach((answer) => {
  //     //   if (answer?.creatorRole === 'mods') {
  //     //     console.log('Adding to expert answers...');
  //     //     setExpertAnswer(answer);
  //     //     return;
  //     //   }
  //     // });
  //     const expertAnswer = item?.children?.find((x) => x.creatorRole === 'mods');
  //     // console.log("Answers => ", JSON.stringify(expertAnswer));
  //     setExpertAnswer(expertAnswer);
  //   }
  // };

  // useEffect(() => {
  //   getExpertDetail();
  // }, [item]);

  useEffect(() => {
    if (questionId) {
      fetchRecommendedProducts(questionId, 'qna');
    }
  }, [questionId]);

  const handleAnswerEvent = (item) => {
    if (pageName) {
      const profileOthersItemClickEvent: INinjaEvent = {
        name: KissanEventType.PROFILE_OTHERS_ITEM_CLICK,
        screenDetails: { screen: 'profile page' },
        eventParams: [addEventParam('itemId', item?.id)],
      };
      enqueue(profileOthersItemClickEvent);
    }
    const answerBoxClickSuccess: INinjaEvent = {
      name: KissanEventType.QNA_ANSWERBOXOPEN_CLICK_SUCCESS,
      screenDetails: { screen: 'qna page' },
      eventParams: [
        addEventParam('questionId', item?.id),
        addEventParam('answerCount', item?.answercount),
      ],
    };
    enqueue(answerBoxClickSuccess);
  };

  const handleDetailNavigation = (item?: IQuestionAnswer) => {
    handleAnswerEvent(item);
    const questionId = item?.id;
    const authorId = item?.author?.creatorid;
    setisAskQuestionDetailPage(false);
    // if (!hasUserLoggedIn()) {
    //   fields['openLoginSheet'].set(true);
    //   fields['previousPage'].set('QNA page');
    //   setNavigationParams({
    //     name: '',
    //     routeName: {
    //       name: `${(lang ?? language) ? language : 'hi'}/qna/${item?.seoUrl}`,
    //       params: { id: questionId, authorId: authorId },
    //     },
    //     description: `${t('page.ViewAnAnswerPage')}`,
    //     screenName: 'QNA page',
    //   });
    // }
    push({
      pathname: `${(lang ?? language) ? language : 'hi'}/qna/${item?.seoUrl}`,
    });
  };

  const handleShare = async (event, item?: IQuestionAnswer) => {
    event.stopPropagation();
    if (!item) {
      return;
    }

    try {
      let url: string = '';
      let type: string = '';

      if (item.medias?.length > 0) {
        const mediaUri = item.medias[0].url;
        const path = await saveImageToTempDir(mediaUri);
        url = `file://${path}`;
        type = 'image/jpeg';
      }
      // Construct the share URL (same for web and mobile)
      const response = await getSeoUrl({ id: item?.id || '', type: 'Qna' });
      let shareUrl = response?.url;
      if (userProfile?.user?.referralCode) {
        shareUrl += `?refCode=${userProfile?.user?.referralCode}`;
      }
      // Prepare the message
      const cleanedBody = item?.body?.replace(/(<a.*?href="([^"]+)".*?<\/a>)|<[^>]*>/g, '');
      const truncatedDescription = cleanedBody?.slice(0, 164);
      const message = `${truncatedDescription} \n \n Click here to view the Question: \n ${shareUrl}`;

      if (Platform.OS === 'web') {
        // Web sharing logic
        if (navigator.share) {
          await navigator.share({
            title: 'Check out this Question',
            text: cleanedBody,
            url: shareUrl,
          });
        }
      } else {
        // Mobile sharing logic
        await Share.open({ url, message, type });
      }
      // Success Event
      const shareClickSuccessEvent: INinjaEvent = {
        name: KissanEventType.QNA_SHARECLICK_SUCCESS,
        screenDetails: { screen: 'qna page' },
        eventParams: [addEventParam('itemUrl', shareUrl), addEventParam('questionId', item?.id)],
      };
      enqueue(shareClickSuccessEvent);
    } catch (error) {
      console.log('Share QnA Post Error', error);
      // Failure Event
      const additionalDetails = [
        addEventParam('errorMessage', error.toString()),
        addEventParam('apiError', safeStringify(error)),
        addEventParam('questionId', item?.id),
      ];
      const shareClickFailedEvent: INinjaEvent = {
        name: KissanEventType.QNA_SHARECLICK_FAIL,
        screenDetails: { screen: 'qna page' },
        eventParams: additionalDetails,
      };
      enqueue(shareClickFailedEvent);
    }
  };

  const onReportBottomSheetOpen = (index) => {
    setCurrentIndex(index);
    reportfields['openReportSheet'].set(true);
    const itemReportEvent: INinjaEvent = {
      name: KissanEventType.ITEM_REPORTED,
      screenDetails: { screen: 'qna page' },
      eventParams: [addEventParam('itemIndex', index)],
    };
    enqueue(itemReportEvent);
  };

  const previewImage = (index) => {
    setSelectedImageIndex(index);
  };

  const translationKey =
    item?.answercount === 1 ? 'page.interpolateViewAnswer' : 'page.viewAnswers';
  const translationText = t(translationKey);
  const interpolatedText = interpolate(translationText, { count: item?.answercount });
  const appLanguage = useAppPersistenceStore((state) => state.appLanguage);
  const [showFollowBtn, setShowFollowBtn] = useState(hasUserLoggedIn() ? !item?.following : true);
  const isFollowStatusUpdatingRef = useRef(false);

  const handleFollowButtonClick = async () => {
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('qna detail page');
      setNavigationParams({
        name: '',
        routeName: {
          name: `${(lang ?? language) ? language : 'hi'}/qna/${item?.seoUrl}`,
          params: { questionDetail: questionId },
        },
        description: `${t('page.commentAnswerQnaPage')}`,
        screenName: 'QNA Detail page',
      });
      return;
    }
    if (isFollowStatusUpdatingRef.current) return;
    isFollowStatusUpdatingRef.current = true;
    try {
      const eventType = item?.following
        ? KissanEventType.QNA_USER_UNFOLLOW
        : KissanEventType.QNA_USER_FOLLOW;
      handleFollowEventClick(item?.author?.creatorid, eventType);
      if (updateConnectionStatus) {
        const response = await updateConnectionStatus(item?.following, item?.author?.creatorid);
        await handleContactPermission();
      } else {
        updateFollowStatus();
      }
    } catch (error) {
      console.error('Error handling follow button click', error);
    } finally {
      isFollowStatusUpdatingRef.current = false;
    }
  };

  const updateFollowStatus = async () => {
    const prevState = item?.following;
    setIsFollowing(!prevState);
    try {
      const config = {
        type: prevState ? 'unfollow' : 'follow',
        formData: {
          sourceObjectId: userProfile?.user?.id ?? '-1',
          sourceObjectType: 'USER',
          destinationObjectId: item?.author?.creatorid!,
          destinationObjectType: 'USER',
          associationType: 'FOLLOWED',
        },
      };
      const response: boolean = await updateFollowStatusApi(config);
      if (!response) {
        setIsFollowing(prevState);
      }
    } catch (error) {
      console.error('Error updating Connection Status', error);
      setIsFollowing(prevState);
    }
  };

  const handleFollowEventClick = (id, event) => {
    const followEvents = {
      name: event,
      screenDetails: { screen: 'follow list page' },
      eventParams: [addEventParam('followedUserId', id)],
    };
    enqueue(followEvents);
  };

  const handleEventOnProfileClick = (ownerId) => {
    const profileClickQnaEvent: INinjaEvent = {
      name: KissanEventType?.PROFILE_CLICK_QNA,
      screenDetails: { screen: 'follow list page' },
      eventParams: [addEventParam('otherUserId', ownerId)],
    };
    enqueue(profileClickQnaEvent);
  };

  const onNavigateProfileTab = () => {
    handleEventOnProfileClick(item?.author?.creatorid);
    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('QNA page');
      setNavigationParams({
        name: '',
        routeName: {
          name: `profile/[id]`,
          params: { id: item?.author?.creatorid, name: truncateName(item?.author?.name, 15) },
        },
        description: `${t('page.viewOnProfilePage')}`,
        screenName: 'QNA  page',
      });
    } else {
      push({
        pathname: `/profile/${item?.author?.creatorid}`,
        query: {
          name: truncateName(item?.author?.name, 15),
        },
      });
    }
  };

  const language = getLanguageFromTags(item?.tags ?? []);

  let modReply = item?.children?.find((x) => x?.creatorRole === 'mods');
  const qnaUrl = `/${(lang ?? language) ? language : 'hi'}/qna/${item?.seoUrl}`;

  return (
    <>
      <Link href={qnaUrl} shallow>
        <Card
          width={'100%'}
          borderRadius={0}
          paddingHorizontal={14}
          paddingVertical={14}
          backgroundColor={'$cardbackground'}
          minHeight={300}
        >
          <YStack
            onPress={onNavigateProfileTab}
            paddingVertical={2}
            testID={`kisan_tId_profile_click_${index}`}
          >
            <XStack
              zIndex={1}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <XStack>
                <Avatar circular size="$5">
                  <Avatar.Image
                    accessibilityLabel="Nate Wienert"
                    source={{
                      uri: AvatarUriLoad(item),
                    }}
                  />
                  <Avatar.Fallback delayMs={600} />
                </Avatar>
                <YStack paddingHorizontal={10}>
                  <Content
                    fontSize={appLanguage == 'ta' ? 14 : 18}
                    fontWeight={'600'}
                    paddingBottom={2}
                    color={'$color'}
                  >
                    {truncateName(
                      item?.author?.name ?? userProfile?.user?.name,
                      showFollowBtn ? 10 : 15
                    )}
                  </Content>
                  <Content fontSize={appLanguage == 'ta' ? 10 : 12} color={'$darkGrey'}>
                    {item?.timestamp && useTimeAgo(item?.timestamp)}
                  </Content>
                </YStack>
              </XStack>

              <XStack alignItems="center" justifyContent="flex-end">
                {showFollowOnCard && showFollowBtn ? (
                  <Button
                    size={30}
                    width={
                      updateConnectionStatus && item?.following ? 120 : isFollowing ? 120 : 100
                    }
                    backgroundColor={'$cardbackground'}
                    borderColor={'$primary'}
                    borderWidth={1}
                    borderRadius={6}
                    marginRight={4}
                    onPress={!isFollowStatusUpdatingRef.current ? handleFollowButtonClick : null}
                    disabled={isFollowStatusUpdatingRef.current}
                    testID={`kisan_tId_follow_button_${index}`}
                  >
                    <View flex={1} flexDirection="row" justifyContent="center" alignItems="center">
                      {!item?.following && <Plus size={18} color="$primary" />}
                      <Text
                        fontSize={appLanguage == 'ta' ? 12 : 14}
                        fontWeight="600"
                        color={'$primary'}
                      >
                        {updateConnectionStatus && item?.following
                          ? t('page.following')
                          : isFollowing
                            ? t('page.following')
                            : t('page.follow')}
                      </Text>
                      {item?.following && (
                        <ChevronDown style={{ marginTop: 2 }} size={18} color="$primary" />
                      )}
                    </View>
                  </Button>
                ) : null}

                <Stack
                  borderRadius={50}
                  borderWidth={1}
                  borderColor={'$primary'}
                  backgroundColor={'$cardbackground'}
                  padding={7}
                  marginHorizontal={4}
                  position="relative"
                  bottom={2}
                  onPress={(e) => handleShare(e, item)}
                  testID={`kisan_tId_share_button`}
                >
                  <ShareSolidRegular color={'#368665'} size={20} />
                </Stack>
                <View
                  onPress={() => onReportBottomSheetOpen(index)}
                  testID={`kisan_tId_report_button_${index}`}
                >
                  <MoreVertical size={30} />
                </View>
              </XStack>
            </XStack>
          </YStack>

          {item?.body && (
            <YStack
              marginTop={15}
              testID={`kisan_tId_qna_card_${index}`}
            >
              <Link href={qnaUrl} shallow>
                <Paragraph fontSize={17} fontWeight={'600'}>
                  <Text color={'$primary'} textTransform="uppercase" fontWeight={'600'}>
                    {t('page.question')}:{' '}
                  </Text>
                  {item?.body}
                </Paragraph>
              </Link>
            </YStack>
          )}

          {item?.medias && item.medias.length > 0 && (
            <XStack marginTop={14} gap={10}>
              {item.medias?.[0]?.type === 'video' ? (
                <>
                  {item.medias?.[0]?.preview_url && !pageName ? (
                    <>
                      <Image
                        source={{ uri: item.medias?.[0]?.preview_url }}
                        key={`qna-video-${index}`}
                        width={cardWidth}
                        height={100}
                        borderWidth={1}
                      />
                      <View style={{ position: 'absolute', top: 36, left: 44 }}>
                        <VideoPlayIconRegular size={28} color={'$background'} />
                      </View>
                    </>
                  ) : (
                    <>
                      <View
                        flex={1}
                        justifyContent="center"
                        alignItems="center"
                        backgroundColor="#000"
                      >
                        {/* <Video
                        source={{ uri: item.medias?.[0]?.url }}
                        style={{
                          width: Dimensions?.get('window')?.width,
                          height: 187,
                        }}
                        controls={true}
                      /> */}
                        <NKPlayer
                          source={{
                            source: {
                              uri: item.medias?.[0]?.url,
                            },
                            itemKey: `qna-video-${index}`,
                          }}
                          style={{
                            width: Dimensions?.get('window')?.width,
                            height: 187,
                          }}
                          config={{ layoutMode: 'basic' }}
                        />
                      </View>
                    </>
                  )}
                </>
              ) : (
                <>
                  {item.medias.length <= 3 ? (
                    item.medias.map((imgUrl, index) => (
                      <Pressable key={`qna-image-${index}`} onPress={() => previewImage(index)}>
                        <Image
                          source={{ uri: imgUrl.url }}
                          width={cardWidth}
                          height={100}
                          borderWidth={1}
                        />
                      </Pressable>
                    ))
                  ) : (
                    <>
                      {item.medias.slice(0, 2).map((imgUrl, index) => (
                        <Pressable key={`qna-image-${index}`} onPress={() => previewImage(index)}>
                          <Image
                            source={{ uri: imgUrl.url }}
                            width={cardWidth}
                            height={100}
                            borderWidth={1}
                          />
                        </Pressable>
                      ))}
                      <ImageBackground
                        source={{
                          uri: `https://blog.castle.io/content/images/2021/03/blog-thumb-1.png`,
                        }}
                        style={{ width: cardWidth, height: 100 }}
                      >
                        <View style={{ backgroundColor: '#393939', flex: 1 }}>
                          <Pressable onPress={() => previewImage(2)}>
                            <Image
                              source={{ uri: item.medias[2]?.url }} // Accessing the third image
                              width={cardWidth}
                              height={100}
                              borderWidth={1}
                              style={{ opacity: 0.3 }}
                            />
                          </Pressable>
                        </View>
                        <Text
                          onPress={() => previewImage(3)}
                          style={{
                            fontSize: 30,
                            color: '#fff',
                            position: 'absolute',
                            bottom: 10,
                            left: 40,
                          }}
                        >
                          +{item.medias.length - 3}
                        </Text>
                      </ImageBackground>
                    </>
                  )}
                </>
              )}
            </XStack>
          )}
          <View
            onPress={() => {
              handleDetailNavigation(item);
            }}
          >
            {modReply && (
              <QnAAnswersWithComments
                reply={modReply}
                showFeedback={showFeedbackOnReplies}
                questionId={item?.id}
                pageExpertName={pageExpertName}
                createCommentQnA={createCommentQnA}
                getQnACommentList={getQnACommentList}
                onQnAReplyLike={onQnAReplyLike}
                useQnaFeedStore={useQnaFeedStore}
                index={index}
                language={language}
              />
            )}

            {((item && item?.children?.length > 0 && !questionId) || pageName) && (
              <Link href={qnaUrl} shallow>
                <XStack
                  marginTop={14}
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <XStack
                    borderWidth={1}
                    borderColor={'$grey'}
                    paddingVertical={4}
                    paddingHorizontal={12}
                    borderRadius={6}
                  >
                    <Pencil color={'$color'} size={13} marginTop={5} />
                    <Paragraph
                      fontSize={15}
                      fontWeight={'500'}
                      color={'$color'}
                      position="relative"
                      left={4}
                      paddingHorizontal={5}
                    >
                      {t('page.answer')}
                    </Paragraph>
                  </XStack>
                  {item?.children && item?.children?.length > 1 && (
                    <Paragraph
                      fontSize={14}
                      // onPress={() => handleDetailPageNavigation(item)}
                      fontWeight={'500'}
                      color={'$color'}
                      textDecorationLine="underline"
                    >
                      {' '}
                      {interpolatedText}
                    </Paragraph>
                  )}
                </XStack>
              </Link>
            )}
          </View>
          {recommendedProducts?.length && questionId ? (
            <>
              <Stack marginTop={10} borderTopColor={'$videoPlayerColor'} borderTopWidth={1}></Stack>
              <View flex={1} marginTop={10}>
                <RecommendedProductsNudgeComponent
                  products={recommendedProducts}
                  t={t}
                  sourcePage={'qna page'}
                />
              </View>
            </>
          ) : null}

          {selectedImageIndex !== null && (
            <ImagePreview
              open={selectedImageIndex !== null}
              setOpen={setSelectedImageIndex}
              index={selectedImageIndex}
              imageUrls={item?.medias}
              onClose={() => setSelectedImageIndex(null)}
            />
          )}
        </Card>
      </Link>
    </>
  );
};
